import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrderHistoryChevron = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M2 0L7 5L12 0L14 1L7 8L0 1L2 0Z",
		fill: "#1A1D1E"
	})]
});
const ForwardRef = forwardRef(SvgOrderHistoryChevron);
export { ForwardRef as ReactComponent };
